import spbSupManApi from '@/service/api/SpbSupManApi';

class SpeV2Service {
	getFilters(params) {
		return spbSupManApi.get('/spev2/filters', { params });
	}

	getOutstanding(params) {
		return spbSupManApi.get('/spev2/outstanding', { params });
	}

	getWaitingConfirmation(params) {
		return spbSupManApi.get('/spev2/waiting-confirmation', { params });
	}

	getPendingCapa(params) {
		return spbSupManApi.get('/spev2/pending-capa', { params });
	}

	getPendingCapaProxy(params) {
		return spbSupManApi.get('/spev2/pending-capa-proxy', { params });
	}

	getDismissed(params) {
		return spbSupManApi.get('/spev2/dismissed', { params });
	}

	getPendingDismiss(params) {
		return spbSupManApi.get('/spev2/pending-dismiss', { params });
	}

	getHistory(params) {
		return spbSupManApi.get('/spev2/history', { params });
	}

	getEmailMapping(params) {
		return spbSupManApi.get('/spev2/email-mapping', { params });
	}

	getEmailMappingSearchOptions(params) {
		return spbSupManApi.get('/spev2/email-mapping/search-options', { params });
	}

	getEmailMappingOptions(params) {
		return spbSupManApi.get('/spev2/email-mapping/options', { params });
	}

	getDetail(scoringId, params) {
		return spbSupManApi.get(`/spev2/detail/${scoringId}`, { params });
	}

	submitEvaluation(payload) {
		return spbSupManApi.post('/spev2/submission', payload);
	}

	dismissEvaluation(payload, file) {
		const formData = new FormData();
		formData.append('payload', JSON.stringify(payload));
		if (file) {
			formData.append('file', file);
		}
		return spbSupManApi.post('/spev2/dismiss', formData, {
			headers: { 'Content-Type': 'multipart/form-data' },
		});
	}

	completeCapaProxy(payload, file) {
		const formData = new FormData();
		formData.append('payload', JSON.stringify(payload));
		if (file) {
			formData.append('file', file);
		}
		return spbSupManApi.post('/spev2/complete-capa-proxy', formData, {
			headers: { 'Content-Type': 'multipart/form-data' },
		});
	}

	confirmEvaluation(payload, file) {
		const formData = new FormData();
		formData.append('payload', JSON.stringify(payload));
		if (file) {
			formData.append('file', file);
		}
		return spbSupManApi.post('/spev2/confirm', formData, {
			headers: { 'Content-Type': 'multipart/form-data' },
		});
	}

	saveEmailMapping(payload) {
		return spbSupManApi.post('/spev2/email-mapping', payload);
	}

	bulkSubmitEvaluation(payload) {
		return spbSupManApi.post('/spev2/bulk-submission', payload);
	}

	checkBulkMailingStatus(payload) {
		return spbSupManApi.post('/spev2/bulk-mailing-check', payload);
	}

	sendSupplierEmail(payload) {
		return spbSupManApi.post('/spev2/send-email', payload);
	}

	approveEvaluation(payload) {
		return spbSupManApi.post('/spev2/approval', payload);
	}

	acknowledgeEvaluation(payload, file) {
		const formData = new FormData();
		formData.append('payload', JSON.stringify(payload));
		if (file) {
			formData.append('file', file);
		}
		return spbSupManApi.post('/spev2/acknowledge', formData, {
			headers: { 'Content-Type': 'multipart/form-data' },
		});
	}

	downloadReport(scoringId, params) {
		return spbSupManApi.get(`/spev2/downloadreport/${scoringId}`, { params });
	}

	getActivity(scoringId) {
		return spbSupManApi.get(`/spev2/activity/${scoringId}`);
	}

	getExportReport(params) {
		return spbSupManApi.get('/spev2/export-report', { params });
	}

	downloadAcknowledgeAttachment(scoringId, params) {
		return spbSupManApi.get(`/spev2/download-attachment/${scoringId}`, { params });
	}

	downloadDismissSupportingDocument(scoringId, params) {
		return spbSupManApi.get(`/spev2/download-dismiss-attachment/${scoringId}`, { params });
	}
}

export default new SpeV2Service();
